import { POINT_TYPES_V2, pointTypesOnZones } from './pointKinds.js';
/** Point steps and the one view each shows (same as its v1 zone picker). */
export const V2_POINT_STEP_VIEWS = {
    body_front: ['front'],
    body_left: ['left'],
    body_rear: ['rear'],
    body_right: ['right'],
    roof: ['top'],
};
/** «Крыша»: the body types plus hail, «Другое» still last. */
export const POINT_TYPES_V2_ROOF = {
    ...POINT_TYPES_V2,
    body: [...POINT_TYPES_V2.body.filter((chip) => chip !== 'other'), 'hail_damage', 'other'],
};
/** Point types per step; a step not listed uses `POINT_TYPES_V2`. */
const V2_POINT_TYPES = {
    roof: POINT_TYPES_V2_ROOF,
};
const toPointStep = (step, pointViews) => {
    if (!step.defect)
        return { ...step };
    const { side, zones } = step.defect;
    const pointTypesByZoneKind = V2_POINT_TYPES[step.key] ?? POINT_TYPES_V2;
    return {
        ...step,
        chips: pointTypesOnZones(zones, pointTypesByZoneKind),
        defect: { side, zones, points: true, pointViews, pointTypesByZoneKind },
    };
};
/** v2 route from the v1 drafts — fresh objects, v1 untouched. */
export const toCatalogueV2 = (v1) => v1.map((step) => {
    const views = V2_POINT_STEP_VIEWS[step.key];
    return views ? toPointStep(step, views) : { ...step };
});
//# sourceMappingURL=catalogue.v2.body.js.map